/**
 * Wave wordmark for the reworked creator surfaces (ROU-1192), ported from the
 * prototype. Renders the `.wave-logo` markup the creator-app stylesheet targets.
 * The signup/login pages keep the existing @/ui/WaveLogo mark.
 */

// The hosted wave logo (same asset the OTP email uses); not bundled into the app.
const LOGO_URL = 'https://cdn.thisisround.co.uk/wave/logo.png';

type Props = {
    compact?: boolean;
};

const WaveLogo = ({ compact = false }: Props) => {
    return (
        <div className={`wave-logo ${compact ? 'wave-logo--compact' : ''}`}>
            <img src={LOGO_URL} alt="Wave" />
        </div>
    );
};

export default WaveLogo;
